import React, { memo } from 'react';
import { Hospital, EditFormData, MapModalState, InsuranceItem } from '../../types/hospital.types';
import HospitalCard from '../HospitalCard/HospitalCard';

interface HospitalListProps {
  hospitals: Hospital[];
  loading: boolean;
  editingCard: string | null;
  saving: string | null;
  editFormData: EditFormData;
  hasChanges: boolean;
  isExpanded: (id: string) => boolean;
  onToggleExpand: (id: string) => void;
  onToggleEdit: (hospital: Hospital, onSave: (id: string, data: any) => void) => void;
  onInputChange: (field: keyof EditFormData, value: string | boolean | InsuranceItem[]) => void;
  onMapOpen: (modal: MapModalState) => void;
  onUpdateHospital: (id: string, data: any) => void;
  onRefreshCounts: () => void;
}

const HospitalList: React.FC<HospitalListProps> = memo(({
  hospitals,
  loading,
  editingCard,
  saving,
  editFormData,
  hasChanges,
  isExpanded,
  onToggleExpand,
  onToggleEdit,
  onInputChange,
  onMapOpen,
  onUpdateHospital,
  onRefreshCounts
}) => {
  if (loading) {
    return <div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div>;
  }

  if (hospitals.length === 0) {
    return <div style={{ textAlign: 'center', padding: '40px' }}>No hospitals found</div>;
  }

  return (
    <div className="hospital-list">
      {hospitals.map(hospital => (
        <HospitalCard
          key={hospital._id}
          hospital={hospital}
          isEditing={editingCard === hospital._id}
          isSaving={saving === hospital._id}
          isExpanded={isExpanded(hospital._id)}
          editFormData={editFormData}
          hasChanges={hasChanges}
          onToggleExpand={onToggleExpand}
          onToggleEdit={onToggleEdit}
          onInputChange={onInputChange}
          onMapOpen={onMapOpen}
          onUpdateHospital={onUpdateHospital}
          onRefreshCounts={onRefreshCounts}
        />
      ))}
    </div>
  );
});

HospitalList.displayName = 'HospitalList';

export default HospitalList;